// src/services/publicUserService.ts
import api from './api';
import { PublicUserProfile, ApiResponse } from '../types';

export const getAllPublicUsers = async (): Promise<PublicUserProfile[]> => {
  try {
    const response = await api.get<ApiResponse<PublicUserProfile[]>>("/admin/public-users");
    return response.data.data;
  } catch (error: any) {
    console.error("getAllPublicUsers error:", {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      baseURL: error.config?.baseURL,
      fullURL: `${error.config?.baseURL || ''}${error.config?.url || ''}`,
    });
    throw error;
  }
};

export interface UpdatePublicUserPayload {
  name?: string;
  email?: string;
  status?: "active" | "suspended";
  active?: boolean;
}

export const updatePublicUser = async (
  userId: number,
  payload: UpdatePublicUserPayload
): Promise<PublicUserProfile> => {
  const response = await api.put<ApiResponse<PublicUserProfile>>(
    `/admin/public-users/${userId}`,
    payload
  );
  return response.data.data;
};

export const blockPublicUser = async (userId: number): Promise<PublicUserProfile> => {
  const response = await api.patch<ApiResponse<PublicUserProfile>>(
    `/admin/public-users/${userId}/block`
  );
  return response.data.data;
};

export const unblockPublicUser = async (userId: number): Promise<PublicUserProfile> => {
  const response = await api.patch<ApiResponse<PublicUserProfile>>(
    `/admin/public-users/${userId}/unblock`
  );
  return response.data.data;
};

export const deletePublicUser = async (userId: number): Promise<void> => {
  await api.delete<ApiResponse<{ message: string }>>(
    `/admin/public-users/${userId}`
  );
};
